import React from 'react'
import { Modal } from 'flowbite-react'
import { AnimatePresence, motion } from 'framer-motion'
import { HiX } from 'react-icons/hi';
import { FC } from 'react';

interface ErorrModalProps {
    show: boolean;
    setShow: (value: boolean) => void;
    emailError: string;
    children?: React.ReactNode;
}

const ErorrModal: FC<ErorrModalProps> = ({ show, setShow, emailError, children }: ErorrModalProps) => {
  return (
    <Modal
      show={show}
      onClose={() => setShow(false)}
    >
      <AnimatePresence>
        {show && (
            <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50"
            >
                <div className="bg-white rounded-xl shadow-xl p-6 max-w-sm w-full">
                    <div className="flex items-center justify-center w-12 h-12 rounded-full bg-red-100 mx-auto mb-4">
                        <HiX className="w-6 h-6 text-red-600" />
                    </div>
                    <h3 className="text-xl font-semibold text-center text-gray-900 mb-2">Error</h3>
                    <p className="text-center text-gray-600 mb-6">
                        {emailError || 'Email already exists. Please use another email address.'}
                    </p>
                    {children}
                    <button
                        onClick={() => setShow(false)}
                        className="w-full px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
                    >
                        Close
                    </button>
                </div>
            </motion.div>
        )}
    </AnimatePresence>
    </Modal>
  )
}

export default ErorrModal